module.exports = "/media/109298015-H-300x205.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/tools/images/109298015-H-300x205.jpg
// module id = 225
// module chunks = 0